import React from 'react'
import CheckCircleOutlineOutlined from '@material-ui/icons/CheckCircleOutlineOutlined'

export default function CheckCircleOutlineOutlinedIcon() {

    return (
        <CheckCircleOutlineOutlined />
    )
}